import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewerModalService } from '../viewer-modal.service';
import { ActorActionsApiClient } from 'src/app/services/api-clients/actor-actions.api-client';
import { DocumentActor } from 'src/app/models/actors';
import { ActorActionEnum } from 'src/app/constants/actor-action.enum';
import { ViewerDataService } from '../viewer-data.service';
import { PerformActionConstants } from '../perform-action.constants';

/**
 * A component that can receive the Actors/Actions for a document
 * And trigger the according Modal for Actor completion.
 */
@Component({
  selector: 'app-document-actions-for-actor',
  templateUrl: './document-actions-for-actor.component.html'
})
export class DocumentActionsForActorComponent implements OnInit {

  @Input() documentIsAPdf: boolean = false;
  @Input() documentGuid!: string;
  /** Emit so it can stay how it was, and i do not need to move all that complex code away from the Page */
  @Output('sign') signEmitter = new EventEmitter();

  currentActor!: DocumentActor;
  allCurrentActors: DocumentActor[] = [];
  firstDocumentActor: DocumentActor | null = null;

  public get navigationId(): string {
    return PerformActionConstants.CreateNavigationIdForDocument(this.documentGuid);
  }
  constructor(private viewerDataService: ViewerDataService, private viewerModalService: ViewerModalService, private actorActionsApiClient: ActorActionsApiClient) {
  }
  GenerateActionId(forActor: DocumentActor) {
    return forActor.action + '_' + forActor.id;
  }

  ngOnInit(): void {

    this.viewerDataService.getCurrentActor$().subscribe(actor => {
      this.currentActor = actor;
    });
    this.viewerDataService.getCurrentActors$().subscribe(actors => {

      if (!actors || actors.length <= 0) {
        this.allCurrentActors = [];
        return;
      }
      this.allCurrentActors = actors.filter(x => x.documentId == this.documentGuid && !x.hasSigned);
      // PDF sign actions are displayed in the document, not below it, filter THOSE out:
      if (this.documentIsAPdf) {
        this.allCurrentActors = this.allCurrentActors.filter(x => x.action != ActorActionEnum.Sign);
      }
      this.firstDocumentActor = this.allCurrentActors.length > 0 ? this.allCurrentActors[0] : null;
    });
  }


  get currentActorIsForDocument(): boolean {
    return this.currentActor && this.firstDocumentActor != null && this.currentActor.documentId == this.documentGuid && this.currentActor.id == this.firstDocumentActor.id;
  }


  public triggerActorModal() {
    if (this.currentActor.action == ActorActionEnum.Sign) {
      this.triggerSign();
    }
    if (this.currentActor.action == ActorActionEnum.Approve) {
      this.triggerApproval();
    }
    if (this.currentActor.action == ActorActionEnum.Adopt) {
      this.triggerAdopt();
    }
    if (this.currentActor.action == ActorActionEnum.Linking) {
      this.triggerLinking();
    }

    if (this.currentActor.action == ActorActionEnum.File) {
      this.triggerFile();
    }
  }


  public async triggerSign() {

    let signAction: any = {
      action: ActorActionEnum.Sign,
      documentId: this.currentActor.documentId
    };
    this.signEmitter.emit(signAction);
  }

  public triggerApproval() {
    var approveModalReference = this.viewerModalService.openActorApprove();
    if (!approveModalReference) {
      return;
    }
  }

  public triggerLinking() {
    var linkingModalReference = this.viewerModalService.openActorLinking();
    if (!linkingModalReference) {
      return;
    }
  }
  public triggerAdopt() {
    var adoptModalReference = this.viewerModalService.openActorAdopt();
    if (!adoptModalReference) {
      return;
    }
  }
  public triggerFile() {
    var fileModalReference = this.viewerModalService.openActorFile();
    if (!fileModalReference) {
      return;
    }
  }
}
